module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/Tabs/images/tab-selected-right.c93165f8.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Tabs/images/tab-selected-right.png
// module id = 3244
// module chunks = 11